//[shopify domain]/browsing_context_suggestions.json
// Redirect

if (!Shopify.designMode) {
    // Global functions that need to be accessible from HTML
    function setCookie(name,value,days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function closePopup() {
        document.querySelector("#redirect-popup").classList.add("hidden");
        document.querySelector("#popup-overlay")?.classList.add("hidden");
        setCookie('redirect', 'true', 999999)
    }

    // Clicking outside the popup will close popup on desktop
    function clickOutside(event, el) {
        if (event.target == el && window.innerWidth > 990) {
            closePopup()
        }
    }

    (function () {
        function getCookie(name) {
            const nameEQ = name + "=";
            let ca = document.cookie.split(';');
            for(let i=0;i < ca.length;i++) {
                let c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        }

        function httpGet(theUrl){
            const xmlHttp = new XMLHttpRequest();
            xmlHttp.open( "GET", theUrl, false ); // false for synchronous request
            xmlHttp.send( null );
            return xmlHttp.responseText;
        }

        const data = httpGet("/browsing_context_suggestions.json")

        const parsedData = JSON.parse(data);
        let country = parsedData.detected_values.country.name;
        
        const auGroup = ['Australia','New Zealand'];
        const isUS = country === 'United States';
        // console.log('Detected country:', country);
        let store = Shopify.shop;
        
        let pathName = '';
        
            pathName = window.location.pathname;
        

        let otherStore = {}

        function openPopup() {
            const redirectPopup = document.querySelector("#redirect-popup")
            const overlay = document.querySelector("#popup-overlay");
            if (redirectPopup && overlay) {
                redirectPopup.innerHTML= redirectPopup.innerHTML.replaceAll('{other_store_name}', otherStore.name).replaceAll('{other_store_currency}', otherStore.currency).replaceAll('{other_store_url}', otherStore.url)
                redirectPopup.classList.remove("hidden");
                overlay.classList.remove("hidden");
            } else {
                console.error('Popup element not found!');
            }
        }

        function checkGEOLocation() {
            if (store == "luv-lou.myshopify.com") {
                otherStore.name = country
                otherStore.currency = 'USD'
                otherStore.url = 'http://luv-lou-usd.myshopify.com/?redirect=false'
                if (isUS) {
                    openPopup();
                }
            }
            else if (store == "luv-lou-usd.myshopify.com") {
                otherStore.name = country
                otherStore.currency = 'AUD'
                otherStore.url = 'http://luv-lou.myshopify.com/?redirect=false'
                if (!isUS) {
                    openPopup();
                }
            } else {
                console.log('Unknown store:', store);
            }
        }

        const url = new URL(location)
        
        // Check if redirect=false is in URL - this means we should clear the cookie and run the check
        if (url.searchParams.get('redirect') == 'false') {
            setCookie('redirect', '', -1); // Clear the cookie
            url.searchParams.delete('redirect')
            history.replaceState({}, '', url)

            checkGEOLocation();
        } else {
            // Normal cookie check
            const cookieRedirect = getCookie('redirect');

            if(!cookieRedirect || cookieRedirect != 'true') {
                checkGEOLocation();
            } else {
                console.log('Skipping redirect check due to cookie');
            }
        }

    })()
}